import { Stamp } from 'lucide-react'
import { useI18n } from '../i18n/useI18n'

interface StampProgressProps {
  count: number
  goal: number
  /** 直近に獲得したスタンプを弾ませる演出用 (StampGate の成功画面で使用) */
  justEarned?: boolean
}

/**
 * スタンプ枠の視覚表示 (#1126)。goal 個の丸枠を並べ、獲得済みを matcha で塗る。
 * goal は管理画面で 1〜30 に設定できるが、表示は横並び wrap で吸収する。
 */
export default function StampProgress({ count, goal, justEarned }: StampProgressProps) {
  const { t } = useI18n()
  return (
    <div className="bg-white rounded-2xl shadow-card p-4">
      <div className="flex items-baseline justify-between mb-3">
        <span className="text-sm font-body text-text-secondary">{t('stampRally.progressLabel')}</span>
        <span className="font-display text-xl text-navy">
          {t('stampRally.progress', { count: String(count), goal: String(goal) })}
        </span>
      </div>
      <div className="flex flex-wrap gap-2.5 justify-center">
        {Array.from({ length: goal }, (_, i) => {
          const earned = i < count
          const isLatest = justEarned && i === count - 1
          return (
            <div
              key={i}
              className={`w-12 h-12 rounded-full flex items-center justify-center border-2 ${
                earned
                  ? 'bg-matcha border-matcha text-white'
                  : 'bg-gray-50 border-dashed border-gray-300 text-gray-300'
              } ${isLatest ? 'animate-scale-in' : ''}`}
            >
              <Stamp size={22} />
            </div>
          )
        })}
      </div>
    </div>
  )
}
